var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('div',{staticClass:"preloader"},[_c('div',{staticClass:"preloder_part"},[_c('div',{staticClass:"spinner"},[_c('div',{staticClass:"dot1"}),_c('div',{staticClass:"dot2"})])])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }